export default __webpack_public_path__ + "static/media/welcome_glitch.f15d3da9.png";